import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-selected", "data-catnav-id", "onClick"]

import { nextTick, ref, watch } from 'vue'

/* global defineProps, defineEmits, withDefaults */

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryNavBar',
  props: {
    items: {},
    activeId: {},
    variant: { default: 'chips' },
    sticky: { type: Boolean, default: false },
    top: { default: 0 }
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const scroller = ref<HTMLElement | null>(null)

// Keeps the active item visible inside the horizontal bar (without scrolling the page)
watch(() => props.activeId, async (id) => {
  await nextTick()
  const bar = scroller.value
  const button = bar?.querySelector<HTMLElement>(`[data-catnav-id="${CSS.escape(String(id))}"]`)
  if (!bar || !button) return
  const left = button.offsetLeft - (bar.clientWidth - button.offsetWidth) / 2
  bar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sf-catnav", [`sf-catnav--${_ctx.variant}`, { 'sf-catnav--sticky': _ctx.sticky }]]),
    style: _normalizeStyle(_ctx.sticky ? { top: `${_ctx.top}px` } : undefined)
  }, [
    _createElementVNode("div", {
      ref_key: "scroller",
      ref: scroller,
      class: "sf-catnav__scroller",
      role: "tablist",
      "aria-label": "Categorias"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.id,
          type: "button",
          role: "tab",
          class: _normalizeClass(["sf-catnav__item", { 'is-active': String(item.id) === String(_ctx.activeId) }]),
          "aria-selected": String(item.id) === String(_ctx.activeId),
          "data-catnav-id": item.id,
          onClick: ($event: any) => (emit('select', String(item.id)))
        }, _toDisplayString(item.name), 11, _hoisted_1))
      }), 128))
    ], 512)
  ], 6))
}
}

})